import React, { Component } from 'react';
import {HandleSubmit} from '../../func/HandleSubmit'
import Select from 'react-select';

class GroupAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Submit: '',
            Products: 'none',
            SendParameters: {},
            Validation: {},
            Loading: true,
            Refresh: true
        };
        //this.state.SendParameters = {};
        this.HandleSubmit = this.HandleSubmit.bind(this);
        this.SetParameterValue = this.SetParameterValue.bind(this);

    }
    SetParameterValue(name, value) {
        this.state.SendParameters = { ...this.state.SendParameters, [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        console.log(this.state.SendParameters);
    }

    async HandleSubmit() {

        var response_info = await HandleSubmit('group/confirmgroup', this.state.SendParameters);
        console.log("response_info: ", response_info);

        if (response_info.status.trim() === "OK") {
            alert("اضافه شد");
            //alert(this.state.Refresh);
            this.setState({
                // Refresh:!this.state.Refresh
            });
        }
        else {
            alert("اشکال در ارتباط");
        }
    }
    async componentDidMount() {
        this.setState({
            Loading: false
        });
    }
    render() {
        if (this.state.Loading) { return "Loading..." }
        return (
            <div>
               <br />
                <StateAccess Refresh={this.state.Refresh} />
            </div >
        );

    }
}
export default (GroupAccess);
class CreateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Loading: true
        }
        this.SetParameterValue = this.props.SetParameterValue.bind(this);
        this.HandleSubmit = this.props.HandleSubmit.bind(this);
    }
    render() {
        const DomComponents =
            [
                {
                    data:
                        <tr key="10">
                            <td>
                                نام گروه
                            </td>
                            <td>
                                <input style={{ "border": "1px solid #000" }} type="text" className="form-control" onChange={(e) => this.SetParameterValue('group_name', e.target.value)} />
                            </td>
                        </tr>
                },
                {
                    data:
                        <tr key="20">
                            <td><button className="btn btn-success" onClick={this.HandleSubmit}>اضافه شود</button>
                            </td>
                        </tr>
                }
            ]
        return (
            <table><tbody>
                {DomComponents.map((item) =>
                    item.data
                )}
            </tbody></table>
        )
    }
}
class StateAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Loading: true,
            StateItem: [],
            GroupName: [],
            Refresh: this.props.Refresh,
            SendParameters: {
                group_code: 0,
                group_label: "",
                group_access: {
                    confirm: {},
                    view: {},
                    edit: {}
                }
            }
        }
        this.GetState = this.GetState.bind(this);
        this.GetAccess = this.GetAccess.bind(this);
        this.GetGroup = this.GetGroup.bind(this);
        console.log("view: ", this.state.SendParameters);
    }
    async GetAccess(group_label_value) {
        this.setState({
            Loading: true,
            SendParameters: { group_code: group_label_value.value, group_label: group_label_value.label }
        });
        var response_info = await HandleSubmit('group/getgroupaccess', { 'group_code': group_label_value.value });
        var GroupAccess = JSON.parse(response_info.group_access);
        //console.log("getaccess12345: ", GroupAccess.view);
        GroupAccess.view = (GroupAccess.view == undefined) ? {} : GroupAccess.view;
        GroupAccess.confirm = (GroupAccess.confirm == undefined) ? {} : GroupAccess.confirm;
        GroupAccess.edit = (GroupAccess.edit == undefined) ? {} : GroupAccess.edit;
        this.state.SendParameters.group_access = { ...this.state.SendParameters.group_access, ["view"]: GroupAccess.view };
        this.state.SendParameters.group_access = { ...this.state.SendParameters.group_access, ["confirm"]: GroupAccess.confirm };
        this.state.SendParameters.group_access = { ...this.state.SendParameters.group_access, ["edit"]: GroupAccess.edit };
        this.setState({
            SendParameters: this.state.SendParameters,
            Loading: false
        });
        //console.log("getaccess10: ", (this.state.SendParameters));
    }
    async GetGroup() {
        //alert(this.state.SendParameters.group_code);
        var response_info = await HandleSubmit('group/getlist', '');
        this.setState({
            GroupName: response_info,
        });
    }
    async GetState() {
        var response_info = await HandleSubmit('getdata/getstate', '');
        //console.log("getstate: ", response_info);
        this.setState({
            StateItem: response_info,
        });
    }
    SetParameterValue(name, value, id) {
        this.state.SendParameters.group_access[name] = { ...this.state.SendParameters.group_access[name], [id]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        //console.log(this.state.SendParameters);
    }
    async HandleSubmit2() {

        var response_info = await HandleSubmit('group/confirmgroupaccess', this.state.SendParameters);
        //console.log("response_info: ", response_info);

        if (response_info.status.trim() === "OK") {
            alert("اعمال شد");
            //alert(this.state.Refresh);
            this.setState({
                // Refresh:!this.state.Refresh
            });
        }
        else {
            alert("اشکال در ارتباط");
        }
    }
    componentWillReceiveProps() {
        this.GetGroup();
    }
    async componentDidMount() {

        await this.GetGroup();
        await this.GetState();
        this.setState({
            Loading: false
        });
    }
    render() {
        if (this.state.Loading) { return <div>Loading......</div> }
        return (
            <React.Fragment>
                <Select
                    options={this.state.GroupName}
                    //id={i.row}
                    defaultValue={{ label: this.state.SendParameters.group_label, value: this.state.SendParameters.group_code }}
                    onChange={(value) => (this.GetAccess(value))} />
                <table className="table"><tbody>
                    <tr>
                        <th>#</th>
                        <th>حالتها</th>
                        <th>مشاهده</th>
                        <th>ایجاد</th>
                        <th>ویرایش</th>
                    </tr>
                    {this.state.StateItem.map((item, index) =>
                        <tr key={index}>
                            <td>{item.row}</td>
                            <td>{item.label}</td>
                            <td onChange={(e) => (this.SetParameterValue("view", e.target.value, item.value))}>
                                <div className="radio">
                                    <label>مربوط به خود</label>
                                    <input type="radio" name={"View_" + item.value + "_" + index} value="user"
                                        defaultChecked={this.state.SendParameters.group_access.view[item.value] === undefined ? false :
                                            this.state.SendParameters.group_access.view[item.value] == "user" ? true : false
                                        } />
                                </div>
                                <div className="radio">
                                    <label>مربوط به همه</label>
                                    <input type="radio" name={"View_" + item.value + "_" + index} value="all"
                                        defaultChecked={this.state.SendParameters.group_access.view[item.value] === undefined ? null :
                                            this.state.SendParameters.group_access.view[item.value] == "all" ? true : false
                                        } />
                                </div>
                                <div className="radio">
                                    <label>  بدون محوز</label>
                                    <input type="radio" name={"View_" + item.value + "_" + index} value="none"
                                        defaultChecked={this.state.SendParameters.group_access.view[item.value] === undefined ? true :
                                            this.state.SendParameters.group_access.view[item.value] == "none" ? true : false
                                        } />
                                </div>
                            </td>
                            <td onChange={(e) => this.SetParameterValue("confirm", e.target.value, item.value)}>
                                <div className="radio">
                                    <label>مربوط به خود</label>
                                    <input type="radio" name={"Confirm_" + item.value + "_" + index} value="user"
                                        defaultChecked={this.state.SendParameters.group_access.confirm[item.value] === undefined ? false :
                                            this.state.SendParameters.group_access.confirm[item.value] == "user" ? true : false
                                        } />
                                </div>
                                <div className="radio">
                                    <label>مربوط به همه</label>
                                    <input type="radio" name={"Confirm_" + item.value + "_" + index} value="all"
                                        defaultChecked={this.state.SendParameters.group_access.confirm[item.value] === undefined ? false :
                                            this.state.SendParameters.group_access.confirm[item.value] == "all" ? true : false
                                        } />
                                </div>
                                <div className="radio">
                                    <label>  بدون محوز</label>
                                    <input type="radio" name={"Confirm_" + item.value + "_" + index} value="none"
                                        defaultChecked={this.state.SendParameters.group_access.confirm[item.value] === undefined ? true :
                                            this.state.SendParameters.group_access.confirm[item.value] == "none" ? true : false
                                        } />
                                </div>
                            </td>
                            <td onChange={(e) => this.SetParameterValue("edit", e.target.value, item.value)}>
                                <div className="radio">
                                    <label>مربوط به خود</label>
                                    <input type="radio" name={"Edit_" + item.value + "_" + index} value="user"
                                        defaultChecked={this.state.SendParameters.group_access.edit[item.value] === undefined ? false :
                                            this.state.SendParameters.group_access.edit[item.value] == "user" ? true : false
                                        } />
                                </div>
                                <div className="radio">
                                    <label>مربوط به همه</label>
                                    <input type="radio" name={"Edit_" + item.value + "_" + index} value="all"
                                        defaultChecked={this.state.SendParameters.group_access.edit[item.value] === undefined ? false :
                                            this.state.SendParameters.group_access.edit[item.value] == "all" ? true : false
                                        } />
                                </div>
                                <div className="radio">
                                    <label>  بدون محوز</label>
                                    <input type="radio" name={"Edit_" + item.value + "_" + index} value="none"
                                        defaultChecked={this.state.SendParameters.group_access.edit[item.value] === undefined ? true :
                                            this.state.SendParameters.group_access.edit[item.value] == "none" ? true : false
                                        } />
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody></table>
                <button className="btn btn-success" onClick={() => this.HandleSubmit2()}> ایجاد </button>
            </React.Fragment>
        )
    }
}




// WEBPACK FOOTER //
// ./src/pages/Group/GroupAccess.js